<template>
    <!--콘텐츠 영역-->
    <div id="sub_contents" class="establish">
        <span>함께해서 더 커지는 기쁨</span>
        <h3>
            이웃의 얼굴에 웃음꽃이 피어나고 미래의 희망인 청년들이 밝게 꿈을 키워나가는 것<br> 
            동국제강이 바라는 아름다운 사회의 모습입니다.
        </h3>
        <div class="cont">
            <div>
                <img :src="require('./../../assets/img/establish.png')">
            </div>
            <div>
                송원문화재단은 동국제강이 1963년 부산에 건설한 주력공장을 포항으로 이전하게 되면서 발생한 이익금을 출연, 
                지역사회에 보답하고자 1996년 12월 설립되었습니다.
                <br><br>
                첫 사업은 1998년 부산지역 학생을 위한 장학금을 지원하는 것이었습니다. 또한 산학단체와 학교에 도서구입비와 연구비를 후원하기도 했습니다.<br>
                이후 동국제강과 함께 장학금지원을 확대하고 어려운 이웃 돕기 등 다양한 봉사활동을 진행했습니다.
                <br><br>
                2004년부터는 전국으로 활동지역을 확대하여 매년 우수 이공계 장학생을 선발하고 장학금을 지원하고 있으며, 
                생활형편이 어려운 학생의 장학금과 생활비를 지원합니다.<br>
                또한 송원아트센터를 통하여 문화예술활동도 꾸준히 확대해 나가고 있습니다.
            </div>
        </div>
    </div>
</template>

<script>

export default {
    data: () => ({
        message: "Establishment.vue"
    }),
    methods: {},
    computed: {
        IS_MOBILE() {
            return this.$root.$data.isMobileMode;
        }
    },
    destroyed() { },
    created() {
        console.log("created - " + this.message);
    }
};
</script>

<style></style>
 


// WEBPACK FOOTER //
// src/components/sub03/Establishment.vue